<template>
  <router-link :to="linkPath" class="category-info" tag="div">
    <!-- FIXME - Change this to flexbox -->
    <div class="block" :style="blockColorString" />
    <!-- FIXME - Do something more elegant than this -->
    <br />
    {{ category.name }}
  </router-link>
</template>

<script>
import db from "../db.js";
import util from "../util.js";

export default {
  name: "category-info-block",
  props: ["category", "categoryId"],
  computed: {
    linkPath() {
      return this.$route.path + "/" + this.categoryId;
    },
    blockColorString() {
      return "background-color: " + util.colors[this.category.color]; //FIXME - Add checking here for valid colors
    },
  },
};
</script>

<style>
.category-info {
  width: 8rem;
  margin: 0.5rem;
  display: inline-block;
  /*border: 1px solid #ddd;*/
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;
}

.category-info .block {
  height: 2rem;
  width: 2rem;
  margin: 1rem;
}
</style>



// WEBPACK FOOTER //
// CategoryInfoBlock.vue?f4457b3a